
(() => {
  if (window.SkinKandyAfterpaySwatches) return;
  window.SkinKandyAfterpaySwatches = true;

  const init = () => {
    const wrapper = document.querySelector('[data-sk-afterpay]');

    if (!wrapper || wrapper.dataset.afterpayReady === 'true') {
      return;
    }

    const priceNode = wrapper.querySelector('#sk-afterpay-price');
    const variantsNode = wrapper.querySelector('[data-sk-afterpay-variants]');

    if (!priceNode || !variantsNode) return;

    let prices;

    try {
      prices = JSON.parse(variantsNode.textContent);
    } catch (error) {
      console.warn('Afterpay variant prices unavailable:', error);
      return;
    }

    const scope =
      wrapper.closest('product-info') ||
      wrapper.closest('.product__info-container') ||
      wrapper.closest('.product') ||
      document;

    const formatter = new Intl.NumberFormat(
      document.documentElement.lang || 'en-AU',
      {
        style: 'currency',
        currency: wrapper.dataset.currency || 'AUD'
      }
    );

    const hasVariant = (id) => {
      return id != null &&
        Object.prototype.hasOwnProperty.call(prices, String(id));
    };

    const updatePrice = (variantId) => {
      if (!hasVariant(variantId)) return;

      const cents = Number(prices[String(variantId)]);

      if (!Number.isFinite(cents)) return;

      const formattedPrice = formatter.format(cents / 100);

      if (priceNode.textContent.trim() !== formattedPrice) {
        priceNode.textContent = formattedPrice;
      }
    };

    const getSelectedVariantId = () => {
      const variantInput =
        scope.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        ) ||
        scope.querySelector(
          'product-form input[name="id"]'
        );

      if (variantInput && hasVariant(variantInput.value)) {
        return variantInput.value;
      }

      const urlVariant = new URLSearchParams(
        window.location.search
      ).get('variant');

      if (hasVariant(urlVariant)) {
        return urlVariant;
      }

      return wrapper.dataset.variantId;
    };

    const syncPrice = () => {
      updatePrice(getSelectedVariantId());
    };

    let scheduled = false;

    const scheduleSync = () => {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        syncPrice();
      });
    };

    const afterInteraction = () => {
      scheduleSync();

      // Allow asynchronous variant updates to finish.
      setTimeout(scheduleSync, 100);
      setTimeout(scheduleSync, 350);
    };

    const isWithinProduct = (target) => {
      return target instanceof Node && scope.contains(target);
    };

    // Native and app-driven option changes
    document.addEventListener('change', (event) => {
      if (isWithinProduct(event.target)) {
        afterInteraction();
      }
    }, true);

    // Swatch King may use clickable labels instead of selects.
    document.addEventListener('click', (event) => {
      if (!isWithinProduct(event.target)) return;

      const target = event.target instanceof Element
        ? event.target
        : event.target.parentElement;

      if (!target) return;

      if (
        target.closest(
          'label, [role="radio"], variant-selects, variant-radios, [class*="swatch"], [data-option-value]'
        )
      ) {
        afterInteraction();
      }
    }, true);

    // Common Shopify theme variant events
    const handleVariantEvent = (event) => {
      const variant =
        event.detail?.variant ||
        event.detail?.currentVariant ||
        event.detail?.selectedVariant;

      if (variant && hasVariant(variant.id)) {
        updatePrice(variant.id);
      } else {
        afterInteraction();
      }
    };

    [
      'variant:change',
      'variantChange',
      'product:variant-change'
    ].forEach((eventName) => {
      document.addEventListener(eventName, handleVariantEvent);
    });

    // Taste/Dawn PubSub compatibility
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (hasVariant(data?.variant?.id)) {
          updatePrice(data.variant.id);
        } else {
          afterInteraction();
        }
      });
    }

    // Detect AJAX updates to the theme's price container.
    const themePrice = scope.querySelector('[id^="price-"]');

    if (themePrice && !themePrice.contains(priceNode)) {
      const priceObserver = new MutationObserver(scheduleSync);

      priceObserver.observe(themePrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Detect changes to the selected Shopify variant input.
    const variantInput = scope.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput) {
      const inputObserver = new MutationObserver(scheduleSync);

      inputObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    wrapper.dataset.afterpayReady = 'true';

    syncPrice();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* Remove interest-free from legacy Afterpay messaging */

(() => {
  if (window.SkinKandyAfterpayTextFix) return;
  window.SkinKandyAfterpayTextFix = true;

  const selector = [
    'afterpay-placement',
    'square-placement',
    '.afterpay-paragraph',
    '[data-afterpay-paragraph]'
  ].join(', ');

  const observedRoots = new WeakSet();

  const removeInterestFree = (root) => {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      if (
        node.parentElement?.closest(
          '[role="dialog"], dialog, [class*="modal"], [id*="modal"]'
        )
      ) {
        continue;
      }

      const original = node.nodeValue;

      if (!original) continue;

      const updated = original.replace(
        /\binterest[\s\u00a0\u2010-\u2015-]*free\b[\s\u00a0]*/gi,
        ''
      );

      if (original !== updated) {
        node.nodeValue = updated;
      }
    }
  };

  const observeRoot = (root) => {
    if (!root || observedRoots.has(root)) return;

    observedRoots.add(root);

    removeInterestFree(root);
    scanPlacements(root);

    const observer = new MutationObserver((mutations) => {
      removeInterestFree(root);

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            scanPlacements(node);
          }
        });
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  function scanPlacements(root = document) {
    if (!root.querySelectorAll) return;

    const placements = [];

    if (root.matches?.(selector)) {
      placements.push(root);
    }

    root.querySelectorAll(selector).forEach((element) => {
      placements.push(element);
    });

    placements.forEach((placement) => {
      // Afterpay Web Components commonly use Shadow DOM.
      if (placement.shadowRoot) {
        observeRoot(placement.shadowRoot);
      }

      // Fallback for legacy messaging without Shadow DOM.
      if (
        placement.matches(
          '.afterpay-paragraph, [data-afterpay-paragraph]'
        )
      ) {
        observeRoot(placement);
      } else if (
        !placement.shadowRoot &&
        /interest[\s\u00a0\u2010-\u2015-]*free/i.test(
          placement.textContent
        )
      ) {
        observeRoot(placement);
      }
    });
  }

  const init = () => {
    scanPlacements();

    // Detect messaging added asynchronously by Afterpay.
    const documentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            scanPlacements(node);
          }
        });
      });
    });

    documentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Allow time for Afterpay to attach its Shadow DOM.
    let attempts = 0;

    const retry = setInterval(() => {
      scanPlacements();

      attempts++;

      if (attempts >= 30) {
        clearInterval(retry);
      }
    }, 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();
